import { render, staticRenderFns } from "./CriarCargo.vue?vue&type=template&id=5e779c89"
import script from "./CriarCargo.vue?vue&type=script&lang=ts"
export * from "./CriarCargo.vue?vue&type=script&lang=ts"
import style0 from "./css/main.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports